import React, { useState, useRef, useEffect } from 'react';
import { Tooltip, Typography } from '@mui/material';

export function TruncatedTooltipText({ text, variant = 'body1', sx, color, fontWeight }) {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const checkTruncate = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    checkTruncate();
    window.addEventListener('resize', checkTruncate);
    return () => window.removeEventListener('resize', checkTruncate);
  }, [text]);

  return (
    <Tooltip title={isTruncated ? text || '' : ''} disableHoverListener={!isTruncated}>
      <Typography
        ref={textRef}
        variant={variant}
        color={color}
        fontWeight={fontWeight}
        noWrap
        sx={{
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          ...sx,
        }}
      >
        {text || '-'}
      </Typography>
    </Tooltip>
  );
}
